import jsPDF from 'jspdf';

const printOrderInvoice = (selectedCustomer, tillUserName, salesRefNo, firstName, lastName,siteName) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [82.5, 297],
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 10; // Initial vertical position

  // Center aligned text
  const centerAlign = (text, fontSize = 10, bold = false) => {
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, y);
    y += fontSize + 1; // Move down for next line
  };

  // Left aligned label + value
  const leftLabelValue = (label, value, fontSize = 9) => {
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', 'normal');
    doc.text(`${label}: ${value}`, 10, y);
    y += fontSize + 1;
  };

  // Print Header
  centerAlign(siteName || '', 12, true);

  // centerAlign('SOUTHALL BRANCH', 10);

  // Horizontal Line
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 3;

  // Customer & Till Info
  leftLabelValue('Customer', selectedCustomer || '-');
  leftLabelValue('Till Number', tillUserName || '-');
  leftLabelValue('Till User', `${firstName} ${lastName || ''}`.trim());

  // Horizontal Line
  y += 2;
  doc.line(10, y, pageWidth - 10, y);
  y += 4;

  // Order Info
  centerAlign('Order Number', 11, true);
  centerAlign(`${salesRefNo}`, 16, true);

  // Optional: Footer or thank you message
  y += 6;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Thank you for your order!', 10, y);

  // Print or Preview
  const filename = `Order_${salesRefNo}.pdf`;
  doc.autoPrint();
  window.open(doc.output('bloburl'));
  doc.save(filename);
};

export default printOrderInvoice;
